const angular = require('angular');
var app = angular.module('learn-controllers');
const moment = require('moment');

app.controller('overviewBadges', ['Application', 'AccessHelper', function(Application, AccessHelper) {
    var self = this;
    self.features = Application.features.flags();
    self.allowance = {
        badges: self.features.badges && AccessHelper.isAllowed(['admin', 'badges'], null, ['admin'])
    };

    if (!self.allowance.badges || Application.access.role !== 'admin') {
        Application.navigation.goTo('/explore');
        return;
    }

}]);